import React, { Suspense, lazy } from "react";
//import "../../assets/admin/css/styles.css";
import AdminPrivateRoutes from "../../AdminPrivateRoutes";
import SecureAdmin from "../../SecureAdmin";

import Navbar from "./Navbar";
import Sidebar from "./Sidebar";
import Footer from "./Footer";

//import Dashboard from "../../components/admin/Dashboard";
import Register from "../../components/admin/Register";
import Report from "../../components/admin/Report";

import Page404 from "../../components/admin/Page404";

/* Added Components */
// import Camera from "../../components/admin/childComponents/appComponents/Camera";
// import Crop from "../../components/admin/childComponents/appComponents/Crop";
// import GPS from "../../components/admin/childComponents/appComponents/GPS";
// import QrCodes from "../../components/admin/childComponents/appComponents/QrCodes";
//import Pdf from "../../components/admin/childComponents/appComponents/Pdf";
// import PrintDoc from "../../components/admin/childComponents/appComponents/PrintDoc";
//import QrScanner from "../../components/admin/childComponents/appComponents/QrScanner";

const Camera = React.lazy(() =>
  import("../../components/admin/childComponents/appComponents/Camera")
);
const Crop = React.lazy(() =>
  import("../../components/admin/childComponents/appComponents/Crop")
);
const GPS = React.lazy(() =>
  import("../../components/admin/childComponents/appComponents/GPS")
);
const QrCodes = React.lazy(() =>
  import("../../components/admin/childComponents/appComponents/QrCodes")
);
const PrintDoc = React.lazy(() =>
  import("../../components/admin/childComponents/appComponents/PrintDoc")
);


const Dashboard = React.lazy(() =>
  import("../../components/admin/Dashboard")
);
const QrScanner = React.lazy(() =>
  import("../../components/admin/childComponents/appComponents/QrScanner")
);
const Pdf = React.lazy(() =>
  import("../../components/admin/childComponents/appComponents/Pdf")
);


const Masterwebpage = (props) => {
  let tagName;

  switch (props.name) {
    case "Dashboard":
      tagName = <Suspense fallback={<div>Loading...</div>}><Dashboard /></Suspense>;
      break;
    case "Register":
      tagName = <Register />;
      break;
    case "Report":
      tagName = <Report />;
      break;

    case "Page404":
      tagName = <Page404 />;
      break;

    /* Added Components */
    case "GPS":
      tagName = <Suspense fallback={<div>Loading...</div>}><GPS /></Suspense>;
      break;
    case "Crop":
      tagName = <Suspense fallback={<div>Loading...</div>}><Crop /></Suspense>;
      break;
    case "PrintDoc":
      tagName = <Suspense fallback={<div>Loading...</div>}><PrintDoc /></Suspense>;
      break;
    case "Pdf":
      tagName = <Suspense fallback={<div>Loading...</div>}><Pdf /></Suspense>;
      break;
    case "QrCodes":
      tagName = <Suspense fallback={<div>Loading...</div>}><QrCodes /></Suspense>;
      break;
    case "QrScanner":
      tagName = <Suspense fallback={<div>Loading...</div>}><QrScanner /></Suspense>;
      break;
    case "Camera":
      tagName = <Suspense fallback={<div>Loading...</div>}><Camera /></Suspense>;
      break;

    default:
      tagName = <Dashboard />;
  }

  return (
    <>
      <AdminPrivateRoutes />
      <SecureAdmin />
      <div id="page-wrapper">
        <Navbar />
        <Sidebar />
        <div className="content-wrapper bg-white">
          <div className="page-content fade-in-up">{tagName}</div>
          <Footer />
        </div>
      </div>
    </>
  );
};
export default Masterwebpage;
